import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    panel_device_id: null,
    device_id: undefined,
    panel_group_id: NaN,
    ord: 0
};
const slice = createSlice({
    name: 'edit_panel_transmitter_dialog',
    initialState,
    reducers: {
        setupEditPanelTransmitterDialog(state, action) {
            state.panel_device_id = action.payload.panel_device_id;
            state.device_id = action.payload.device_id;
            state.panel_group_id = action.payload.panel_group_id;
            state.ord = action.payload.ord;
        },
        setEditPanelTransmitterDialogDeviceID(state, action) {
            state.device_id = action.payload;
        },
        setEditPanelTransmitterDialogPanelGroupID(state, action) {
            state.panel_group_id = action.payload;
        },
        setEditPanelTransmitterDialogOrd(state, action) {
            state.ord = action.payload;
        },
    }
});
export const { setupEditPanelTransmitterDialog, setEditPanelTransmitterDialogDeviceID, setEditPanelTransmitterDialogPanelGroupID, setEditPanelTransmitterDialogOrd, } = slice.actions;
export const edit_panel_transmitter_dialog = slice.reducer;
